import React from 'react';
import { useSelector } from 'react-redux';
import { useSitemap, useLabels, usePrefs } from 'wsm-common-data';

const PromotionLink = () => {
	const sitemap = useSitemap();
	const labels = useLabels();
	const { promotionLinkStyle, promotionLinkLabel } = usePrefs();
	const { vehicleData } = useSelector((state) => state);

	const modelParam = vehicleData.model
		? `model=${encodeURIComponent(vehicleData.model)}`
		: '';

	return (
		<a
			className={`btn ${promotionLinkStyle} mt-3`}
			href={`${sitemap.get('PROMOTIONS_LISTING_NEW')}?${modelParam}`}
		>
			{labels.get(promotionLinkLabel)}
		</a>
	);
};

export default PromotionLink;
